
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { formatYearMonthDay } from '@xt/client/utils/my'

@Observer
@Component({
  components: {}
})
export default class CalendarCard extends Vue {
  @Prop() dataSource: {
    y: number
    m: number
    d: number
    timestamp: number
    activeTime: number
    currentTime: number
    isExistClasshour: boolean
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  get isCurrentDay() {
    const { y, m, d } = formatYearMonthDay(this.dataSource.currentTime)
    return this.dataSource.y === y && this.dataSource.m === m && this.dataSource.d === d
  }
  get isActiveDay() {
    const { y, m, d } = formatYearMonthDay(this.dataSource.activeTime)
    return this.dataSource.y === y && this.dataSource.m === m && this.dataSource.d === d
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
